<template>
  <div>  
    <EditViewForm 
      v-if="inner_mode==='edit'"
      :handle_dynamic_form_update="handle_dynamic_form_update"
      :handle_file_upload="handle_file_upload"
      :handle_file_remove="handle_file_remove"
      :page_structure="page_structure"
      :preloaded_data="metadata"
      :init_flag="form_init_flag"
      :preloaded_rules="rules"
      @update-valid="(valid)=>{form_valid = valid}"
      mode="edit"
    />
    <EditViewForm 
      v-else-if="inner_mode==='add'"
      :handle_dynamic_form_update="handle_dynamic_form_update"
      :handle_file_upload="handle_file_upload"
      :handle_file_remove="handle_file_remove"
      :page_structure="page_structure"
      :preloaded_data="metadata"
      :init_flag="form_init_flag"
      :preloaded_rules="rules"
      @update-valid="(valid)=>{form_valid = valid}"
      mode="add"
    />
  
    <span slot="footer" class="dialog-footer">
      <el-button v-if="inner_mode==='edit' || inner_mode==='add'" type="primary" @click="handle_save_button_click">儲存</el-button>
    </span>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import EditStructure from '@/views/backstage/structure/digital_object_page/DigitalObjectEditPageStructure'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'

  export default {
    components: {
      LoadingBlock,
      EditViewForm
    },
    props: [
        'mode','resource_name','resource_identifier','host_resource_identifier','route_root','type','dialog_visible','dialog_refersh'],
    data() {
      return {
        loading: false,//TODO: change this to true
        active_tab_name: 'metadata',
        page_structure: [],
        metadata: {}, 
        file_lists: {},
        inner_mode: 'edit',
        form_init_flag: 0,
        rules: {},
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/' + this.resource_name,
        form_valid: true
      }
    },
    watch:{
      resource_identifier: function (val) {
        this.init()
      },
      mode: function (val) {
        this.init()
      },
      dialog_visible: function () {
        this.init()
        this.form_init_flag += 1
      }
    },
    created: function () {
      this.init()
    },
    methods: {
      init () {
        console.log('DigitalObjectDetailPage: digital object, type:', this.type)
        console.log('DigitalObjectDetailPage: digital object, resource_identifier:', this.resource_identifier)

        if (!this.type || !this.resource_identifier) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '沒有數位物件的類型或編號')
          return 
        }

        if (this.mode !== 'edit' && this.mode !== 'add') {
          this.notify_message(this.ERROR.LEVEL.ERROR, '編輯模式錯誤')
          return 
        }

        this.inner_mode = this.mode

        this.page_structure = EditStructure(this.type)
        console.log('DigitalObjectDetailPage: digital object, edit structure:', this.page_structure)   

        let metadata_temp = this.forge_context_container(this.page_structure)

        this.metadata = JSON.parse(JSON.stringify(metadata_temp))

        this.file_lists = {}

        this.get_metadata()
        
        this.rules = this.retrieve_validation_rule(this.page_structure)
      },
      handle_edit_button_click () {
        console.log('DigitalObjectDetailPage: edit button clicked')
        this.backstage_router_push({ path: `/${this.route_root}/${this.$route.params.type}/edit/${this.id}` })
      },
      get_metadata () {

        if (this.inner_mode === 'add') {
          console.log('DigitalObjectDetailPage: in "add" mode, skip data retrieving')
          return
        }

        if (typeof this.resource_identifier['value'] === 'undefined' || this.resource_identifier['value'] === null) {
          console.log('warn: DigitalObjectDetailPage: insufficient info to get digital object')
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得數位物件', '沒有數位物件的編號')
          return
        }

        this.loading = true
        let params = {}
        params[this.resource_identifier['name']] = this.resource_identifier['value']
        
        axios.get(this.resource_api+'/get', {params})
            .then((response) => {
              this.loading = false
              console.log('DigitalObjectDetailPage: GET: response: ', response.data.payload)
              if (response.data.success) {
                this.metadata = this.translate_to_edit_data(this.page_structure, response.data.payload, {mode: 'edit'})

                // foreign key
                this.metadata[this.foreign_key] = response.data.payload[this.foreign_key]
              }
              else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得數位物件', response.data.message)
              }
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得數位物件', this.ERROR.MSG.general_err_msg)
            })
      },
      handle_save_button_click () {
        if (!this.form_valid) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', '表格不符格式')
          return
        }

        if (this.inner_mode==='add' && (!Array.isArray(this.file_lists['do_files']) || this.file_lists['do_files'].length === 0)) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', '沒有上傳的檔案')
          return
        }

        let self = this

        console.log('DigitalObjectDetailPage, save button clicked')
        console.log('DigitalObjectDetailPage: this.file_lists:', this.file_lists)
        
        let param = new FormData(); 
        let n = this.file_lists['do_files'] && this.file_lists['do_files'].length? this.file_lists['do_files'].length : 0

        let forge_field = null
        if (this.inner_mode === 'add') {
          forge_field = (param, field, n, value) => {
            for (let i =0; i < n; i+= 1) {
              param.append(`${field['change']['name']}[${i}]`, value)
            }
          }
        }
        else if (this.inner_mode === 'edit') {
          forge_field = (param, field, _, value) => {
            param.append(`${field['change']['name']}`, value)
          }
        }
        else {
          console.log('err: DigitalObjectDetailPage: incorrect mode: ', this.inner_mode)
          return
        }

        for (let field of this.page_structure['fields']) {
          if (field['change']['editable'] || field['change']['addable']) {
            if (field['change']['type'] === 'string' || field['change']['type'] === 'datetime') {
              forge_field(param, field, n, this.metadata[field['source']['key']])
            }
            else if (field['change']['type'] === 'multiple-file') {
              if (this.file_lists[field['change']['name']]) {
                for (let i =0; i < n; i+= 1) {
                  param.append(`${field['change']['name']}[${i}]`, this.file_lists[field['change']['name']][i].file)
                }
              }
            }
            else if (field['change']['type'] === 'single-select') {
              if (this.metadata[field['change']['name']]) {
                forge_field(param, field, n, this.metadata[field['change']['name']])
              }
            }
            else {
              if (this.metadata[field['source']['key']]) {
                forge_field(param, field, n, this.metadata[field['source']['key']])
              }
            }
          }
        }
        
        // resource identifier
        param.append(this.resource_identifier['name'], this.resource_identifier['value']);
        param.append(this.host_resource_identifier['name'], this.host_resource_identifier['value']);

        let config = { headers:{'Content-Type':'multipart/form-data'} } 

        if (this.inner_mode !== 'edit' && this.inner_mode != 'add') {
          console.log('err: modifying digital object with  incorrect mode:', this.inner_mode)
          return 
        }

        axios.post(this.resource_api+'/'+this.inner_mode, param, config)
          .then (response => { 
            if (!response.data.success) {
              console.log('DigitalObjectDetailPage: save/edit failed, msg='+response.data.message+', reponse=', response)
              this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', response.data.message)
              return
            }

            console.log('DigitalObjectDetailPage: save/edit succeed, response=', response)

            if (response.data.payload[self.resource_identifier['name']]) {
              if (Array.isArray(response.data.payload[self.resource_identifier['name']])) {
                self.resource_identifier['value'] = response.data.payload[self.resource_identifier['name']][0]
              }
              else {
                self.resource_identifier['value'] = response.data.payload[self.resource_identifier['name']]
              }
            }
            
            this.notify_message(this.ERROR.LEVEL.SUCCESS, this.inner_mode === 'add'? '新增成功': '修改成功')

            self.$emit('update:update_flag')
            self.$emit('cancel')
            //self.get_metadata()
            return
          }) 
          .catch(({err}) => { 
            console.log('DigitalObjectDetailPage: save/edit failed, err=', err)
            this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', this.ERROR.MSG.general_err_msg)
          }) 
      },
      handle_file_upload (file_list_name, file) {
        console.log('DigitalObjectDetailPage: handle file upload: file=',file_list_name, file)
        if (!this.file_lists[file_list_name]) {
          this.file_lists[file_list_name] = []
        }
        this.file_lists[file_list_name].push(file)
      },
      handle_file_remove (file_list_name, file) {
        console.log('DigitalObjectDetailPage: handle file remove: file=',file_list_name, file)
        if (this.file_lists[file_list_name] === null){
          return
        }

        let index = -1
        for (let i=0;i<this.file_lists[file_list_name].length; i += 1){
          if (this.file_lists[file_list_name][i].file.uid === file.uid) {
            index = i
            break
          }
        }

        if (index != -1) {
          this.file_lists[file_list_name].splice(index, 1)
        }
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('DigitalObjectDetailPage: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.metadata, key, form_value)
      }
    },
  };
</script>

<style lang="scss" scoped>

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-radio{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  width: 300px;
}
</style>
